const stackOrder = {
    dropdownMenu: 1000,
    globalLayoutNavOption: 2000,
    globalLayoutNav: 3000,
    modal: 4000,
};
export default stackOrder;
//# sourceMappingURL=stackOrder.js.map